import { http } from "../utils/http";

export const login = (data) => http.post("/weilan/api/user/info/login", data);
export const getMenu = (data) =>
  http.post("/weilan/api/user/info/getModuleList", data);
